import { Globe, Check } from "@phosphor-icons/react";
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { useLang } from "@/i18n/LanguageContext";

export default function LanguageSwitcher() {
  const { lang, setLang, langs } = useLang();
  const current = langs.find((l) => l.code === lang) || langs[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-full border border-white/10 text-white/70 hover:text-white hover:border-white/25 transition-colors text-sm"
          aria-label="Change language"
        >
          <Globe size={16} />
          <span className="hidden sm:inline font-mono-num uppercase text-xs tracking-widest">
            {current.code}
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        data-testid="language-menu"
        className="bg-[color:var(--surface-2)] border-white/10 text-white min-w-[160px]"
      >
        {langs.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className="focus:bg-white/10 cursor-pointer flex items-center justify-between"
          >
            <span>{l.name}</span>
            {l.code === lang && <Check size={14} className="text-[color:var(--accent)]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
